import { h } from 'preact'
import { connect } from 'unistore/preact'
import { Block, Row } from 'jsxstyle/preact'
import {
  ArrowDownwardIcon,
  ArrowUpwardIcon,
  BasicDialog,
  DeleteIcon,
  DropdownMenu,
  EditIcon,
  List,
  ListItem,
  MoreIcon,
  SpacerVertical
} from '@sodra/bongo-ui'
import { goBack, Route, routeTo } from '@sodra/prutt'

import SettingsTabs from '../SettingsTabs'

import CreateColor from './CreateColor'
import EditColor from './EditColor'
import DeleteColor from './DeleteColor'
import EditDefaultColor from './EditDefaultColor'
import { useState } from 'preact/hooks'
import { moveColorDown, moveColorUp } from '../../../actions/colors.js'

export const formatColorRule = (color) => {
  if (color.attribute.type === 'boolean') {
    if (color.operand === 'eq') {
      return `${color.attribute.name} är markerad`
    }
    return `${color.attribute.name} inte är markerad`
  }
  if (color.attribute.type === 'text') {
    if (color.operand === 'eq') {
      return `${color.attribute.name} är "${color.value}"`
    }
    if (color.operand === 'not') {
      return `${color.attribute.name} inte är "${color.value}"`
    }
    if (color.operand === 'contains') {
      return `${color.attribute.name} innehåller "${color.value}"`
    }
    if (color.operand === 'not_contains') {
      return `${color.attribute.name} inte innehåller "${color.value}"`
    }
  }
  if (color.operand === 'eq') {
    return `${color.attribute.name} = ${color.value}`
  }
  if (color.operand === 'lt') {
    return `${color.attribute.name} < ${color.value}`
  }
  if (color.operand === 'lte') {
    return `${color.attribute.name} <= ${color.value}`
  }
  if (color.operand === 'gt') {
    return `${color.attribute.name} > ${color.value}`
  }
  if (color.operand === 'gte') {
    return `${color.attribute.name} >= ${color.value}`
  }
  if (color.operand === 'not') {
    return `${color.attribute.name} <> ${color.value}`
  }
}

const Colors = ({ project, isNarrow }) => {
  const [color, setColor] = useState()
  const [colorIndex, setColorIndex] = useState()
  const [menu, setMenu] = useState()

  const closeMenu = () => setMenu()

  const onClose = () => goBack(`/projects/${project.id}`)

  return (
    <BasicDialog
      large={!isNarrow}
      full={isNarrow}
      flexGrowContent={isNarrow}
      disableAutofocus
      title="Inställningar"
      action1Text="Stäng"
      onAction1Click={onClose}
      secondaryActionText="Ny färg"
      secondaryActionStyle="outlined"
      onSecondaryActionClick={() => routeTo(`/projects/${project.id}/colors/create-color`)}
      onClose={onClose}
    >
      <SettingsTabs active={'colors'} />
      <SpacerVertical />
      <List>
        {project.colors.map((color, index) => {
          return (
            <ListItem
              text={
                <Row align-items="center" justify-content="flex-start" gap="10px">
                  <Block
                    backgroundColor={color.color}
                    width="20px"
                    height="20px"
                    borderRadius="100%"
                  />
                  <Block>{formatColorRule(color)}</Block>
                </Row>
              }
              actionIcon={MoreIcon}
              onActionClick={({ type, target, x, y }) => {
                setColor(color)
                setColorIndex(index)
                if (type === 'keyboard') {
                  setMenu({ positionElement: target })
                } else {
                  setMenu({ position: { x, y } })
                }
              }}
              onClick={() => routeTo(`/projects/${project.id}/colors/edit-color/${color.id}`)}
            />
          )
        })}
        <ListItem
          text={
            <Row align-items="center" justify-content="flex-start" gap="10px">
              <Block
                backgroundColor={project.defaultColor}
                width="20px"
                height="20px"
                borderRadius="100%"
              />
              <Block>{project.colors.length > 0 ? 'Övriga' : 'Alla punkter'}</Block>
            </Row>
          }
          actionIcon={MoreIcon}
          onActionClick={({ type, target, x, y }) => {
            setColor()
            if (type === 'keyboard') {
              setMenu({ positionElement: target })
            } else {
              setMenu({ position: { x, y } })
            }
          }}
          onClick={() => routeTo(`/projects/${project.id}/colors/edit-default-color`)}
        />
      </List>
      {menu && (
        <DropdownMenu
          onClose={closeMenu}
          position={menu.position}
          positionElement={menu.positionElement}
        >
          <SpacerVertical tiny />
          <List autofocus delayClick>
            {color && (
              <ListItem
                icon={EditIcon}
                text="Ändra"
                onClick={() => {
                  routeTo(`/projects/${project.id}/colors/edit-color/${color.id}`)
                  closeMenu()
                }}
              />
            )}
            {color && colorIndex > 0 && (
              <ListItem
                icon={ArrowUpwardIcon}
                text="Flytta upp"
                onClick={() => {
                  moveColorUp(color.id)
                  closeMenu()
                }}
              />
            )}
            {color && colorIndex < project.colors.length - 1 && (
              <ListItem
                icon={ArrowDownwardIcon}
                text="Flytta ner"
                onClick={() => {
                  moveColorDown(color.id)
                  closeMenu()
                }}
              />
            )}
            {color && (
              <ListItem
                icon={DeleteIcon}
                text="Ta bort"
                onClick={() => {
                  routeTo(`/projects/${project.id}/colors/delete-color/${color.id}`)
                  closeMenu()
                }}
              />
            )}
            {!color && (
              <ListItem
                icon={EditIcon}
                text="Ändra"
                onClick={() => {
                  routeTo(`/projects/${project.id}/colors/edit-default-color`)
                  closeMenu()
                }}
              />
            )}
          </List>
          <SpacerVertical tiny />
        </DropdownMenu>
      )}
      <Route path="/projects/:projectId/colors/create-color" component={CreateColor} />
      <Route path="/projects/:projectId/colors/edit-color/:colorId" component={EditColor} />
      <Route path="/projects/:projectId/colors/delete-color/:colorId" component={DeleteColor} />
      <Route path="/projects/:projectId/colors/edit-default-color" component={EditDefaultColor} />
    </BasicDialog>
  )
}

export default connect('project, isNarrow')(Colors)
